import React from "react";

export const PageHeader = ({ eyebrow, title, intro }) => (
  <section className="bg-[#050505] text-white pt-36 pb-20 px-6 md:px-12 lg:px-16">
    <div className="max-w-[1400px] mx-auto">
      <p className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#D4FF00] mb-6">{eyebrow}</p>
      <h1 className="font-display font-semibold text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.9] max-w-[14ch]">{title}</h1>
      {intro && <p className="text-zinc-300 text-lg max-w-2xl mt-8 leading-relaxed">{intro}</p>}
    </div>
  </section>
);
